// AdminLogin.js
import React, { useState } from 'react';
import axios from 'axios';

const AdminLogin = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const URL = 'https://chat-api.b2bdev.net/login';
  // const URL = 'http://localhost:3001/login';

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(URL, { username, password });
      if (res.data.success) {
        // Save the token and username (for simplicity, in localStorage)
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('adminUsername', res.data.username);
        onLogin(res.data.username);
      }
    } catch (err) {
      console.error(err);
      setError('Invalid credentials.');
    }
  };

  return (
    <div style={{ width: '300px', margin: '100px auto', padding: '20px', border: '1px solid #ddd', borderRadius: '4px', background: '#fff' }}>
      <h2>Admin Login</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '10px' }}>
          <input 
            type="text" 
            placeholder="Username" 
            value={username} 
            onChange={(e) => setUsername(e.target.value)} 
            style={{ width: '100%', padding: '8px' }} 
            autoComplete="on"
          />
        </div>
        <div style={{ marginBottom: '10px' }}>
          <input 
            type="password" 
            placeholder="Password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            style={{ width: '100%', padding: '8px' }} 
            autoComplete="on"
          />
        </div>
        <button 
          type="submit" 
          style={{ width: '100%', padding: '10px', background: '#4A90E2', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
        >
          Login
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
